var BufferListConnectionView = require('bufferlistconnectionview');
var Keyboard = require('../../lib/keyboard.es6').default;


var BufferListView = Backbone.View.extend({
    tagName: 'ul',
    className: 'bufferList',
    attributes: {
        'role': 'tablist'
    },
    initialize: function (options, sidebar) {
        this.sidebar = sidebar;
        this.container = $('#buffers');
        this.dragHelperContainer = $('.bufferList--dragHelperContainer');
        this.indicators = $('.sidebarIndicator');
        this.indicatorAbove = $('#sidebarIndicatorAbove');
        this.indicatorBelow = $('#sidebarIndicatorBelow');
        this.tooltip = $('.sidebarIndicatorTooltip');
        this.tooltipVisible = false;
        this.tooltipSummary = $('.sidebarIndicatorTooltip__summary');

        this.initPins();

        _.bindAll(this, 'updateIndicators', 'docKeyDown', 'indicatorClick',
            'indicatorHoverOn', 'indicatorHoverOff', 'indicatorWheel');

        this.indicators.on('click', this.indicatorClick);
        this.indicators.hover(this.indicatorHoverOn, this.indicatorHoverOff);
        this.indicators.on('mousewheel', this.indicatorWheel);

        this.model.bind('doneLoading', this.updateIndicators);
        this.model.bind('prefChange:layout-left', this.updateIndicators, this);
        this.model.bind('change:database_status', this.updateIndicators, this);

        this.model.connections.bind('add', this.renderConnection, this);
        this.model.connections.bind('remove', this.removeConnection, this);
        this.model.connections.bind('reset', this.resetConnections, this);
        this.model.connections.bind('change:status change:fail_info', this.updateIndicators, this);
        this.model.connections.bind('moveTo', this.moveConnectionTo, this);
        this.model.bind('reorderConnections', this.clickReorderNetworks, this);

        $('button#reorderNetworksDone').on('buttonClick', _.bind(this.clickReorderNetworks, this));

        this.connections = {};

        // All connections have been rendered by this point
        this.model.bind('init', this.render, this);

        this.sidebar.$el.scroll(this.updateIndicators);
        $(window).resize(this.updateIndicators);
        $(document).keydown(this.docKeyDown);
    },
    clickReorderNetworks: function (e) {
        e.preventDefault();
        this.sidebar.wrapper.toggleClass('reorder');
    },
    itemToView: function (item) {
        return _.find(this.connections, function (cv, id) {
            return $(item).is(cv.el);
        });
    },
    moveConnectionTo: function (connection, at) {
        var cv = this.connections[connection.id];
        var curIdx = $(cv.el).index();
        if (curIdx === at) {
            return;
        } else {
            var ref = this.$('li.connection').eq(at);
            if (curIdx < at) {
                ref.after(cv.el);
            } else {
                ref.before(cv.el);
            }
        }
    },
    indicatorClick: function (e) {
        e.preventDefault();
        if (e.altKey || e.shiftKey) {
            this.select($(e.target).data('scrollBuffer'));
        } else {
            this.scrollToView($(e.target).data('scrollTarget'));
        }
    },
    indicatorHoverOn: function (e) {
        if ($(e.target).is(this.indicatorBelow)) {
            this.tooltipVisible = 'below';
        } else {
            this.tooltipVisible = 'above';
        }
        this.renderTooltip();
    },
    indicatorHoverOff: function (e) {
        this.tooltipVisible = false;
        this.renderTooltip();
    },
    indicatorWheel: function (e) {
        var currentScroll = this.sidebar.$el.scrollTop();
        var delta = e.originalEvent.wheelDelta;
        var scrollTo = currentScroll - delta;
        this.scrollSidebarTo(scrollTo);
    },
    scrollToView: function (el) {
        var $el = $(el);

        var sidebarTop = this.getSidebarTop();
        var sidebarBottom = sidebarTop + this.getSidebarHeight();

        var elemTop = $el.offset().top;
        var elemBottom = elemTop + $el.height();

        if ((elemBottom >= sidebarBottom) || (elemTop <= sidebarTop)) {
            var to = elemTop + this.sidebar.$el.scrollTop();
            this.scrollSidebarTo(to - 23);
        }
    },
    renderConnectionSortable: function () {
        // http://api.jqueryui.com/sortable/
        var grabPosition = 17;
        this.$el.sortable({
            revert: 100,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            cursorAt: {top: grabPosition},
            distance: 5,
            axis: 'y',
            cursor: 'move',
            opacity: 0.7,
            handle: 'h2.buffer'
        });
        this.$el.on('sortbeforestart', _.bind(function (e, ui) {
            this.sidebar.wrapper.addClass('reorder--jit');
            var scrollTo = this.sidebar.$el.scrollTop() + ui.item.offset().top - e.clientY;
            var maxScrollTop = this.sidebar.el.scrollHeight - this.getSidebarHeight();
            var topAdjustedScrollTo = 0;
            if (scrollTo < 0) {
                topAdjustedScrollTo = -scrollTo;
                this.container.css('margin-top', topAdjustedScrollTo);
                scrollTo = 0;
            } else if (scrollTo > maxScrollTop) {
                topAdjustedScrollTo = -scrollTo;
                this.container.css('margin-bottom', this.getSidebarHeight() + scrollTo - maxScrollTop);
            }
            this.scrollSidebarTo(scrollTo);
            var sidebarRect = this.sidebar.getRect();
            this.dragHelperContainer.css({
                top: sidebarRect.top,
                left: sidebarRect.left,
                width: sidebarRect.width,
                height: sidebarRect.height,
                'margin-top': topAdjustedScrollTo
            }).show();
        }, this));
        this.$el.on('sortstart', _.bind(function (e, ui) {
            ui.helper.appendTo(this.dragHelperContainer);
        }, this));
        this.$el.on('sortstop', _.bind(function (e, ui) {
            this.dragHelperContainer.hide();
            this.sidebar.wrapper.removeClass('reorder--jit');
            this.container.css({
                'margin-top': 0,
                'margin-bottom': 0
            });
            this.scrollToView(ui.item);
            _.each(this.connections, function (cv, cid) {
                cv.model.setOrder(cv.$el.index() + 1);
            });
            this.model.connections.saveOrder();
        }, this));
    },
    renderPinnedSortable: function (el) {
        // http://api.jqueryui.com/sortable/
        el.sortable({
            revert: 100,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            axis: 'y',
            cursor: 'move',
            opacity: 0.7,
            helper: 'clone'
        });
        el.on('sortstop', _.bind(function (e, ui) {
            var order = _.map(this.pinnedBufferList.find('li.buffer'), function (item) {
                return $(item).data('bid');
            });
            this.model.setPinnedOrder(order);
        }, this));
    },
    initPins: function () {
        this.pinnedBuffers = $('<ul class="bufferList pinnedBuffers pinnedBuffers--hidden">');
        var head = $('<h2>').text('Pinned').prepend('<i class="fa fa-thumb-tack">');
        this.pinnedBuffers.append(head);
        this.pinnedBufferList = $('<ul class="pinnedBufferList">');
        this.pinnedBuffers.append(this.pinnedBufferList);
        this.container.append(this.pinnedBuffers);
        this.renderPinnedSortable(this.pinnedBufferList);
    },
    renderPins: function () {
        this.pinnedBuffers.toggleClass('pinnedBuffers--hidden', !this.model.hasPinnedBuffers());
    },
    getFirstPinnedBuffer: function () {
        return this.model.pinnedBuffers.first();
    },
    getLastPinnedBuffer: function () {
        return this.model.pinnedBuffers.last();
    },
    getNextPinnedBuffer: function (buffer) {
        return this.model.pinnedBuffers.next(buffer);
    },
    getPreviousPinnedBuffer: function (buffer) {
        return this.model.pinnedBuffers.previous(buffer);
    },
    render: function () {
        this.container.append(this.el);
        this.renderConnectionSortable();
        this.renderPins();

        this.model.bind('beforeConnectionRemove', this.renderConnectionRemoved, this);
        this.model.connections.bind('beforeBufferRemove', this.renderBufferRemoved, this);
        this.model.buffers.bind('change:archived', this.renderBufferArchived, this);
        this.listenTo(this.model.pinnedBuffers, 'changed', this.renderPins);
        this.model.bind('unseenChange', this.updateIndicators);
        this.model.buffers.bind('unseenHighlightChange', this.updateIndicators);

        return this;
    },
    renderBufferArchived: function (buffer) {
        if (!buffer.isServerLog() && !buffer.wasArchived()) {
            this.renderBufferRemoved(buffer);
            this.updateIndicators();
        }
    },
    renderBufferRemoved: function (buffer) {
        this.updateIndicators();
        if (!buffer.isSelected()) {
            return;
        }
        var options = {replace: true};
        this.model.selectPreviousBuffer(options) || this.selectPreviousOrTopBuffer(buffer, options);
    },
    renderConnectionRemoved: function (connection) {
        this.updateIndicators();
        if (!connection.isSelected()) {
            return;
        }
        var options = {replace: true};
        this.model.selectPreviousBuffer(options) || this.selectConnectionPreviousOrTopBuffer(connection, options);
    },
    resetConnections: function () {
        for (var cid in this.connections) {
            this.connections[cid].remove();
        }
        this.connections = {};
    },
    removeConnection: function (connection) {
        delete this.connections[connection.id];
        this.stopListening(connection, 'init');
    },
    renderConnection: function (connection) {
        var view = new BufferListConnectionView({
            model: connection,
            parent: this
        });
        this.listenTo(connection, 'init', function () {
            var index = this.model.connections.indexOf(connection);
            view.render();
            var existing = this.$el.children();
            if (index == existing.length) {
                this.$el.append(view.el);
            } else {
                existing.eq(index).before(view.el);
            }
        }, this);
        view.bind('scrollTo', this.scrollToView, this);
        view.bind('toggleArchives', this.updateIndicators, this);
        this.connections[connection.id] = view;
    },
    scrollSidebarTo: function (position) {
        this.sidebar.$el.scrollTop(position);
    },

    getNextBuffer: function (buffer, important) {
        if (important === false) {
            return this.getNextBufferFromConnection(buffer) ||
                   this.recurseFirstBuffers(buffer.connection, false);
        }
        return this.getNextBufferFromConnection(buffer, true) || // next important buffer
               this.recurseFirstBuffers(buffer.connection, true) || // forward connections first important buffer
               !important && this.getNextBufferFromConnection(buffer) || // next buffer
               !important && this.recurseFirstBuffers(buffer.connection); // forward connections first buffer
    },
    getPreviousBuffer: function (buffer, important) {
        if (important === false) {
            return this.getPreviousBufferFromConnection(buffer) ||
                   this.recurseLastBuffers(buffer.connection);
        }
        return this.getPreviousBufferFromConnection(buffer, true) || // previous important buffer
               this.recurseLastBuffers(buffer.connection, true) || // back connections last important buffer
               !important && this.getPreviousBufferFromConnection(buffer) || // previous buffer
               !important && this.recurseLastBuffers(buffer.connection); // back connections last buffer
    },
    getFirstBufferForSelection: function () {
        var firstConnection = this.model.connections.first();
        if (firstConnection) {
            var buffer;
            if (firstConnection.isCollapsed()) {
                buffer = this.getNextConnectionFirstBuffer(firstConnection, true);
            }
            buffer = firstConnection.buffers.getFirstBuffer(true) ||
                     this.recurseFirstBuffers(firstConnection, true) ||
                     firstConnection.buffers.getFirstBuffer();
            return buffer;
        }
    },
    getNextConnectionFirstBuffer: function (connection, important) {
        var nextConnection = this.model.connections.next(connection);
        if (nextConnection) {
            if (important && nextConnection.isCollapsed()) {
                return this.getNextConnectionFirstBuffer(nextConnection, true);
            }
            return nextConnection.buffers.getFirstBuffer(true) ||
                   this.recurseFirstBuffers(nextConnection, true) ||
                   !important && nextConnection.buffers.getFirstBuffer() ||
                   !important && nextConnection.serverLog;
        }
    },
    getLastBufferForSelection: function () {
        var lastConnection = this.model.connections.last();
        if (lastConnection) {
            var buffer = lastConnection.buffers.getLastBuffer(true) ||
                         this.recurseLastBuffers(lastConnection, true);
            return buffer;
        }
    },
    importanceCheck: function (important, index) {
        return !important || index > -1;
    },
    getPreviousBufferFromConnection: function (buffer, important) {
        if (buffer.isServerLog()) {
            return null;
        }
        var connection = buffer.connection;
        if (important && connection.isCollapsed()) {
            return null;
        }
        var segment = connection.buffers.findSegment(buffer);

        var result;
        var orders = connection.buffers.getOrder(important);
        var index = _.indexOf(orders, segment);
        // Try to get the previous from the current segment, if it
        // passes the importance check
        if (this.importanceCheck(important, index)) {
            result = segment.previous(buffer);
        }
        if (!result) {
            // Find the index for the previous segment in the list
            index--;
            if (!this.importanceCheck(important, index)) {
                // Failed the importance check so find the nearest preceding one
                var all_orders = connection.buffers.getOrder();
                var all_index = _.indexOf(all_orders, segment);
                while (all_index > -1 && index < 0) {
                    index = _.indexOf(orders, all_orders[--all_index]);
                }
            }
            // Try to get the last of each preceding segment
            while (index > -1 && !result) {
                result = orders[index].last();
                index--;
            }
        }
        if (!important && !result) {
            return connection.serverLog;
        }
        return result;
    },
    getNextBufferFromConnection: function (buffer, important) {
        var connection = buffer.connection;
        if (important && connection.isCollapsed()) {
            return null;
        }
        var segment = connection.buffers.findSegment(buffer);

        var result;
        var orders = connection.buffers.getOrder(important);
        var index = _.indexOf(orders, segment);
        if (segment && this.importanceCheck(important, index)) {
            // Try to get the next from the current segment, if it
            // passes the importance check
            result = segment.next(buffer);
        }
        if (!result) {
            // Find the index for the next segment in the list
            if (segment) {
                index++;
                if (!this.importanceCheck(important, index)) {
                    // Failed the importance check so find the nearest subsequent one
                    var all_orders = connection.buffers.getOrder();
                    var all_index = _.indexOf(all_orders, segment);
                    while (all_index < all_orders.length && index < 0) {
                        index = _.indexOf(orders, all_orders[++all_index]);
                    }
                }
            } else {
                // No segment, use first (e.g. server log)
                index = 0;
            }
            // Try to get the first of each subsequent segment
            while (index < orders.length && !result) {
                result = orders[index++].first();
            }
        }
        return result;
    },
    recurseFirstBuffers: function (connection, important) {
        var nextConnection = this.model.connections.next(connection);
        var buffer;
        while (nextConnection && !buffer) {
            if (important === false) {
                buffer = nextConnection.serverLog;
            } else {
                if (!important || !nextConnection.isCollapsed()) {
                    buffer = nextConnection.buffers.getFirstBuffer(true) ||
                             !important && nextConnection.buffers.getFirstBuffer() ||
                             !important && nextConnection.serverLog;
                }
                nextConnection = this.model.connections.next(nextConnection);
            }
        }
        return buffer;
    },
    recurseLastBuffers: function (connection, important) {
        var previousConnection = this.model.connections.previous(connection);
        var buffer;
        while (previousConnection && !buffer) {
            if (important === false) {
                buffer = previousConnection.buffers.getLastBuffer() ||
                         previousConnection.serverLog;
            } else {
                if (!important || !previousConnection.isCollapsed()) {
                    buffer = previousConnection.buffers.getLastBuffer(true) ||
                             !important && previousConnection.buffers.getLastBuffer() ||
                             !important && previousConnection.serverLog;
                }
            }
            previousConnection = this.model.connections.previous(previousConnection);
        }
        return buffer;
    },

    docKeyDown: function (e) {
        // Keyboard shortcuts
        if (e.altKey) { // holding alt
            switch (e.which) {
            case Keyboard.KEYS.UP:
                if (e.shiftKey) {
                    this.selectPreviousUnreadBuffer();
                } else {
                    this.selectPreviousBuffer();
                }
                return false;
            case Keyboard.KEYS.DOWN:
                if (e.shiftKey) {
                    this.selectNextUnreadBuffer();
                } else {
                    this.selectNextBuffer();
                }
                return false;
            }
        }
        return true;
    },
    updateIndicators: function () {
        var sidebarRect = this.sidebar.getRect();
        this.indicatorBelow.css('top', sidebarRect.bottom - this.indicatorBelow.height() - 1);

        var initCss = {
            width: sidebarRect.width,
            left: sidebarRect.left
        };
        var tooltipCss = {};
        var tooltipHPad = 5;
        initCss.left = sidebarRect.left;
        if (this.model.getPref('layout-left')) {
            tooltipCss.left = initCss.width + tooltipHPad;
        } else {
            tooltipHPad += 2;
            tooltipCss.left = initCss.left - this.tooltip.outerWidth(true) - tooltipHPad;
        }

        this.indicators
            .css(initCss)
            .removeClass('sidebarIndicatorUnread')
            .removeClass('sidebarIndicatorBadged')
            .removeClass('sidebarIndicatorFailed')
            .removeData('scrollTarget')
            .removeData('scrollBuffer');
        this.tooltip.css(tooltipCss);
        if (!this.model.isInitialized()) {
            return;
        }
        var sidebarHeight = this.getSidebarHeight();
        var sidebarTop = this.getSidebarTop();
        this.tooltipData = this.tooltipInit();
        _.each(this.connections, function (connectionView, cid) {
            var connection = this.model.getConnection(cid);
            if (connection && connection.isFailed()) {
                var serverLog = connection.serverLog;
                var top = connectionView.$el.offset().top - sidebarTop;
                var bottom = top + connectionView.$el.height();
                if (bottom < 5) {
                    this.tooltipData.above.failed++;
                    this.indicatorAbove.addClass('sidebarIndicatorFailed');
                    this.indicatorAbove.data('scrollTarget', connectionView.$el);
                    this.indicatorAbove.data('scrollBuffer', serverLog);
                }
                if (top + 5 > sidebarHeight) {
                    this.tooltipData.below.failed++;
                    this.indicatorBelow.addClass('sidebarIndicatorFailed');
                    this.indicatorBelow.data('scrollTarget', connectionView.$el);
                    this.indicatorBelow.data('scrollBuffer', serverLog);
                }
            }
        }, this);
        this.model.unseenBuffers.each(_.bind(function (buffer) {
            var bufferView;
            if (buffer.connection.isCollapsed()) {
                bufferView = this.connections[buffer.getCid()].buffers[buffer.connection.serverLog.bid()];
            } else {
                bufferView = this.connections[buffer.getCid()].buffers[buffer.bid()];
            }
            var bufferEl = bufferView.$el;
            if (bufferEl.is(':visible')) {
                var top = bufferEl.offset().top - sidebarTop;
                var bottom = top + bufferEl.height();
                if (bottom < 5) {
                    this.tooltipData.above.buffers++;
                    this.indicatorAbove.addClass('sidebarIndicatorUnread');
                    if (buffer.hasUnseenHighlights()) {
                        this.indicatorAbove.addClass('sidebarIndicatorBadged');
                        this.tooltipData.above.highlights += buffer.unseenHighlightCount();
                    }
                    this.indicatorAbove.data('scrollTarget', bufferEl);
                    this.indicatorAbove.data('scrollBuffer', buffer);
                }
                if (top + 5 > sidebarHeight) {
                    this.tooltipData.below.buffers++;
                    this.indicatorBelow.addClass('sidebarIndicatorUnread');
                    if (buffer.hasUnseenHighlights()) {
                        this.indicatorBelow.addClass('sidebarIndicatorBadged');
                        this.tooltipData.below.highlights += buffer.unseenHighlightCount();
                    }
                    this.indicatorBelow.data('scrollTarget', bufferEl);
                    this.indicatorBelow.data('scrollBuffer', buffer);
                }
            }
        }, this));
        if (this.tooltipVisible) {
            this.renderTooltip();
        }
    },
    tooltipInit: function () {
        return {
            above: {
                buffers: 0,
                highlights: 0,
                failed: 0
            },
            below: {
                buffers: 0,
                highlights: 0,
                failed: 0
            }
        };
    },
    renderTooltip: function () {
        if (this.tooltipVisible) {
            var data = this.tooltipData[this.tooltipVisible];
            if (data.highlights || data.buffers || data.failed) {
                var css = {};
                var vPadding = 5;
                if (this.tooltipVisible == 'below') {
                    var belowRect = this.indicatorBelow[0].getBoundingClientRect();
                    css.top = 'auto';
                    css.bottom = ($(window).height() - belowRect.bottom) + vPadding;
                } else if (this.tooltipVisible == 'above') {
                    css.top = vPadding;
                    css.bottom = 'auto';
                }
                var className = 'sidebarIndicatorTooltip--' + this.tooltipVisible;
                this.tooltip
                    .css(css)
                    .removeClass('sidebarIndicatorTooltip--above')
                    .removeClass('sidebarIndicatorTooltip--below')
                    .addClass(className)
                    .addClass('sidebarIndicatorTooltip--show');

                this.tooltipSummary.html('');
                if (data.highlights) {
                    var s = data.highlights > 1 ? 's' : '';
                    this.tooltipSummary.append(
                        $('<span class="sidebarIndicatorTooltip__highlights">')
                            .append($('<span class="sidebarIndicatorTooltip__badge">').text(data.highlights))
                            .append('&nbsp;highlight' + s)
                    );
                }
                if (data.buffers) {
                    if (data.highlights) {
                        this.tooltipSummary.append(' •&nbsp;');
                    }
                    this.tooltipSummary.append(
                        $('<span class="sidebarIndicatorTooltip__buffers">')
                            .html(data.buffers + '&nbsp;unread')
                    );
                }
                if (data.failed) {
                    if (data.highlights || data.buffers) {
                        this.tooltipSummary.append(' •&nbsp;');
                    }
                    this.tooltipSummary.append(
                        $('<span class="sidebarIndicatorTooltip__failed">')
                            .html(data.failed + '&nbsp;failed')
                    );
                }
            } else {
                this.tooltipVisible = false;
                this.renderTooltip();
            }
        } else {
            this.tooltip.removeClass('sidebarIndicatorTooltip--show');
        }
    },
    getSidebarHeight: function () {
        return this.sidebar.el.offsetHeight;
    },
    getSidebarTop: function () {
        return this.sidebar.el.offsetTop;
    },
    select: function (buffer, options) {
        if (buffer) {
            buffer.select(options);
            return true;
        }
        return false;
    },
    selectOrClear: function (buffer, options) {
        if (this.select(buffer, options)) {
            return true;
        } else {
            this.model.clearCurrentBuffer();
            return false;
        }
    },
    selectConnectionPreviousOrTopBuffer: function (connection, options) {
        var bufferToSelect = this.getPreviousBufferForSelection(connection.serverLog, true) ||
                             this.getNextConnectionFirstBuffer(connection, true) ||
                             this.getPreviousBuffer(connection.serverLog) ||
                             this.getNextConnectionFirstBuffer(connection);
        return this.selectOrClear(bufferToSelect, options);
    },
    selectPreviousOrTopBuffer: function (buffer, options) {
        var bufferToSelect = this.getPreviousBufferForSelection(buffer, true) ||
                             this.getNextBufferForSelection(buffer, true) ||
                             this.getPreviousBuffer(buffer) ||
                             this.getNextBuffer(buffer);
        return this.selectOrClear(bufferToSelect, options);
    },
    getPreviousBufferForSelection: function (buffer, important) {
        var backup = this.getLastPinnedBuffer() ||
                     this.getLastBufferForSelection();
        if (buffer) {
            var ret;
            if (buffer.isPinned()) {
                ret =  this.getPreviousPinnedBuffer(buffer) ||
                       this.getLastBufferForSelection();
            } else {
                ret =  this.getPreviousBuffer(buffer, important) ||
                       backup;
            }
            if (ret && ret.equals(buffer)) {
                ret = this.getPreviousBuffer(ret);
            }
            return ret;
        } else {
            return backup;
        }
    },
    getNextBufferForSelection: function (buffer, important) {
        var backup = this.getFirstPinnedBuffer() ||
                     this.getFirstBufferForSelection();
        if (buffer) {
            if (buffer.isPinned()) {
                return this.getNextPinnedBuffer(buffer) ||
                       this.getFirstBufferForSelection();
            } else {
                return this.getNextBuffer(buffer, important) ||
                       backup;
            }
        } else {
            return backup;
        }
    },
    selectPreviousBuffer: function (options) {
        this.select(this.getPreviousBufferForSelection(this.model.currentBuffer, true), options);
    },
    selectNextBuffer: function (options) {
        this.select(this.getNextBufferForSelection(this.model.currentBuffer, true), options);
    },
    selectPreviousUnreadBuffer: function (options) {
        if (this.model.unseenBuffers.length) {
            var prev = this.getPreviousBufferForSelection(this.model.currentBuffer, false);
            while (prev) {
                if (prev && prev.hasUnseen() && (prev.isTrackingUnread() || prev.hasUnseenHighlights())) {
                    return this.select(prev, options);
                }
                prev = this.getPreviousBufferForSelection(prev, false);
            }
        }
    },
    selectNextUnreadBuffer: function (options) {
        if (this.model.unseenBuffers.length) {
            var next = this.getNextBufferForSelection(this.model.currentBuffer, false);
            while (next) {
                if (next && next.hasUnseen() && (next.isTrackingUnread() || next.hasUnseenHighlights())) {
                    return this.select(next, options);
                }
                next = this.getNextBufferForSelection(next, false);
            }
        }
    }
});

module.exports = BufferListView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistview.js
// module id = OFe6
// module chunks = 1